// @flow

import React from 'react';
import { connect } from 'react-redux';
import {
  getIsFetching,
  getIsError,
  getThreads,
  getFilter,
  getIsFiltering,
} from '../reducers/threads';
import {
  filterThreadsSearch,
  filterThreadsTracked,
  filterThreadsUnread,
  trackThread,
  createThread,
} from '../actions/threads';
import * as Immutable from 'immutable';
import PageLoader from 'shared/components/PageLoader';
import { Message } from 'semantic-ui-react';
import { List, Filter, CreateThreadModal } from '../components/threads';
import type { Thread } from '../types';
import type { State as StoreState } from '../reducers';
import type { FilterState } from '../reducers/threads';

type Props = {
  history: any,
  threads: Immutable.List<Thread>,
  filter: FilterState,
  isFetching: boolean,
  isFiltering: boolean,
  isError: boolean,
  createThread: (thread: Thread) => void,
  filterThreadsSearch: (value: string) => void,
  filterThreadsTracked: (value: boolean) => void,
  filterThreadsUnread: (value: boolean) => void,
  trackThread: (id: string, value: boolean) => void,
};

type State = {
  createThreadModalOpen: boolean,
};

const mapStateToProps = (state: StoreState) => ({
  isFetching: getIsFetching(state),
  isError: getIsError(state),
  isFiltering: getIsFiltering(state),
  threads: getThreads(state),
  filter: getFilter(state),
});

class Threads extends React.Component<Props, State> {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      createThreadModalOpen: false,
    };
  }

  showCreateThreadModal = () =>
    this.setState({
      createThreadModalOpen: true,
    });

  hideCreateThreadModal = () =>
    this.setState({
      createThreadModalOpen: false,
    });

  render() {
    const {
      history,
      isFetching,
      isError,
      isFiltering,
      threads,
      filter,
      filterThreadsSearch,
      filterThreadsTracked,
      filterThreadsUnread,
      trackThread,
    } = this.props;

    const { createThreadModalOpen } = this.state;

    if (isFetching) {
      return <PageLoader />;
    }

    if (isError) {
      return (
        <Message
          error
          header="Une erreur est survenue"
          content="Veuillez nous excuser pour les désagréments occasionnés"
          icon="bomb"
        />
      );
    }

    return (
      <div className="list-container">
        <Filter
          search={filter.search}
          unread={filter.unread}
          tracked={filter.tracked}
          onCreateThread={this.showCreateThreadModal}
          onSearchChanged={filterThreadsSearch}
          onTrackedChanged={filterThreadsTracked}
          onUnreadChanged={filterThreadsUnread}
        />
        <List
          history={history}
          filter={filter}
          threads={threads}
          isFiltering={isFiltering}
          onTrack={trackThread}
        />
        <CreateThreadModal
          open={createThreadModalOpen}
          onCreated={this.props.createThread}
          onClose={this.hideCreateThreadModal}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, {
  filterThreadsSearch,
  filterThreadsTracked,
  filterThreadsUnread,
  createThread,
  trackThread,
})(Threads);



// WEBPACK FOOTER //
// ./src/modules/messaging/pages/Threads.js